import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import General_FAQ_Seo from '../../SEO/General_FAQ_Seo';

function GeneralFAQ() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 500); // Simulating a 1-second delay
  }, []);
  return (
    <div>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <General_FAQ_Seo />
          <div className='page-wrapper'>
            <Header />
            {/* Internal CSS */}
            <style>
              {`
                            .header-wrap.style1 .header-top .header-top-left .contact-item a, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a i {
                                color: #fff;
                            }
                                .header-wrap.style1 .header-top .header-top-left .contact-item a:hover, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a:hover i {
                                color: #FF414B;
                            }
                        `}
            </style>
            {/* Content Wrapper Start */}
            <div className="content-wrapper">
              {/* Breadcrumb start */}
              <div className="breadcrumb-wrap bg-f">
                <div className="overlay bg-vulcan op-9" />
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="breadcrumb-title">
                        <h2>Frequently Asked Questions</h2>
                        <ul className="breadcrumb-menu list-style">
                          <li><NavLink to="/">Home </NavLink></li>
                          <li>Frequently Asked Questions</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumb end */}
              {/* Frequently Asked Questions section start */}
              <section className="faq-wrap ptb-100">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="content-title style1 mb-40">
                        <span>FAQ</span>
                        <h2>Frequently Asked Questions</h2>
                      </div>
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Why do you need my documents while registration?
                            </button>
                          </h2>
                          <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style={{}}>
                            <div className="accordion-body">
                              <div className="single-product-text">
                                <p>
                                  We are regulated by Financial Conduct Authority in the UK. It is our legal binding to verify your identity as a UK resident.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              How can I cancel my transfer?
                            </button>
                          </h2>
                          <div id="collapseTwo" className="accordion-collapse collapse " aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                Please call us or email us at earliest possible if you want to cancel your transfer. Transfer paid out to the recipient cannot be cancelled. If you have paid for your transfer and the transfer is not processed yet, then please contact us by phone and we will make necessary arrangements for refunds. We may charge you a small fee as handling/service charge and refund you the balance amount.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Will I get notifications about Transfer status?
                            </button>
                          </h2>
                          <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                Yes. We send email notifications to keep you informed. You can even view the transfer status by signing in into your web account.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingfour">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              How many recipients I can add?
                            </button>
                          </h2>
                          <div id="collapsefour" className="accordion-collapse collapse " aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <div className="single-product-text">
                                <p>
                                  There is no restriction on the number of recipients you may have on your account.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingfive">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              You asked me to upload one more document; how can I do that?
                            </button>
                          </h2>
                          <div id="collapsefive" className="accordion-collapse collapse " aria-labelledby="headingfive" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                Please login in to your account and under My Account you will find document section where you can upload the document.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingsix">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              How can I pay for my transfer?
                            </button>
                          </h2>
                          <div id="collapsesix" className="accordion-collapse collapse " aria-labelledby="headingsix" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                Bank Transfer to our business account and payments made by using credit or debit cards. Bank Transfer is the recommended and preferred method of payment. There may be restrictions on credit and debit card payment as well as there may be a fee charged on top.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingseven">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseseven" aria-expanded="false" aria-controls="collapseseven">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Why I received email stating transfer complete, but the money is not with recipient?
                            </button>
                          </h2>
                          <div id="collapseseven" className="accordion-collapse collapse " aria-labelledby="headingseven" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <p>
                                Our pay-out partner bank/agent may have completed the transfer process but the recipient's bank would not have displayed it in their account. Please allow couple of hours to be displayed, if the problem persists then please contact our support team. We will make sure money is with your recipient as promised.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingeight">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseseight" aria-expanded="false" aria-controls="collapseseight">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Good to know
                            </button>
                          </h2>
                          <div id="collapseseight" className="accordion-collapse collapse " aria-labelledby="headingeight" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <ul className="list">
                                <li>Age: 18 years and above</li>
                                <li>We will verify your identity, this will not affect your credit ratings</li>
                                <li>You must be resident of the UK</li>
                                <li>Activation of account will be based on the documents you provide</li>
                                <li>Monthly sending limits may apply</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingnine">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesnine" aria-expanded="false" aria-controls="collapsesnine">
                              <span>
                                <i className="las la-plus-circle plus" />
                                <i className="las la-minus-circle minus" />
                              </span>
                              Documents Required
                            </button>
                          </h2>
                          <div id="collapsesnine" className="accordion-collapse collapse " aria-labelledby="headingnine" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <ul className="list">
                                <li>Photo Identity Proof (Passport, EU Nationality card or UK Driving License).</li>
                                <li>Address Proof (Utility bill, Bank Statement, Council Tax bill not less than 3 months old).</li>
                                <li>Source of funds document.</li>
                                <li>Company Houses Registration (mandatory for Corporate Accounts).</li>
                                <li>Company Address Proof (mandatory for Corporate Accounts).</li>
                                <li>Company Bank Statement (mandatory for Corporate Accounts).</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* Frequently Asked Questions section end */}
            </div>
            {/* Content Wrapper End */}


            {/* Footer Section Here */}
            <Footer />
          </div>
        </>
      )}
    </div>
  );
}

export default GeneralFAQ;
